
export const InputsCheck = (props) => {

    const { label = 'Checkbox', name = "", value = '', checked = false, disabled = false, onHandleChange = null } = props

    return (
        <label className="d-flex align-items-center">
            <input
                type="checkbox"
                name={name}
                value={value}
                onChange={onHandleChange}
                disabled={disabled}
                checked={checked}
                style={{
                    padding: '7px',
                    border: '1px solid lightgray',
                    borderRadius: '4px',
                    fontSize: '16px',
                    backgroundColor: 'white',
                    height: '18px',
                    width: '18px',
                    cursor: 'pointer'
                }}
            />
            <span
                style={{
                    color: 'rgba(0, 0, 0, 0.6)',
                    marginLeft: '5px',
                    fontSize: '14px'
                }}
            >
                {label}
            </span>
        </label>
    )
}